import {
  createSlice,
  PayloadAction,
  createAsyncThunk,
  ActionReducerMapBuilder,
} from '@reduxjs/toolkit'
import { AppHttpConfig as API } from '../../../services/httpConfig'
import hasObjectData from '../../../utils/hasObjectData'
import queryStringBuilder, { QueryParams } from '../../../utils/queryStringBuilder'
import showResponseError from '../../../utils/showResponseError'
import {
  CitiesStat,
  IReportInitialState,
  PaymentReport,
  PreReserveCanceled,
  PreReserveNotPaid,
  PreReserveNotPaidDetails,
  PreReservePaid,
  PreReservePaidDeatils,
  PreReserveStat,
  PreReserveStatus,
  SajayaRelationStat,
  TPreReserveCanceledDetails,
  TReportList,
} from './types'
import { ReportUrl } from './urls'

const initialState: IReportInitialState = {
  loading: false,
  preReserveStatusReport: {
    currentPage: 1,
    loading: false,
    list: { total: 0, data: [] },
  },
  preReservePaidReport: {
    paidLoading: false,
    paidList: { total: 0, data: [] },
    searchParams: {},
  },
  preReservePaidDetailsReport: {
    paidDetailsLoading: false,
    paidDetailsList: { total: 0, data: [] },
  },
  preReserveNotPaidReport: {
    notPaidLoading: false,
    notPaidList: { total: 0, data: [] },
    searchParams: {},
  },
  preReserveNotPaidDetailsReport: {
    notPaidDetailsLoading: false,
    notPaidDetilsList: { total: 0, data: [] },
  },
  preReserveCanceledReport: {
    canceledLoading: false,
    canceledList: { total: 0, data: [] },
    searchParams: {},
  },
  preReserveCanceledDetailsReport: {
    canceledDetailsLoading: false,
    canceledDetailsList: { total: 0, data: [] },
  },
  preReserveStatReport: {
    statLoading: false,
    statList: { total: 0, data: [] },
  },
  paymentDetails: {
    paymentLoading: false,
    paymentList: { total: 0, data: [] },
  },

  sajayaRelationtReport: {
    sajayaRelationtLoading: false,
    sajayaRelationtList: { total: 0, data: [] },
  },
  citiesStatReport: {
    citiesStatLoading: false,
    citiesStatList: { total: 0, data: [] },
  },
}
// get by status
export const getPreReserveByStatus = createAsyncThunk<TReportList<PreReserveStatus[]>, QueryParams>(
  'report/getPreReserveByStatus',
  async (data: QueryParams) => {
    const query = hasObjectData(data) ? queryStringBuilder(data) : ''
    try {
      const response = await API.get(`${ReportUrl.GetAllByStatus}${query}`)
        .then((res) => {
          if (res.status === 200) {
            return res.data
          }
          if (res.status === 204) {
            return res.data
          }
        })
        .catch((error) => {
          showResponseError(error)
        })
      return response
    } catch (error) {
      showResponseError(error)
    }
  },
)

// Get Pre-reserve Paid Stat
export const getPreReservePiadStat = createAsyncThunk<TReportList<PreReservePaid[]>, QueryParams>(
  'report/getPreReservePiadStat',
  async (data: QueryParams) => {
    const query = hasObjectData(data) ? queryStringBuilder(data) : ''
    try {
      const response = await API.get(`${ReportUrl.GetPreReservPaid}${query}`)
        .then((res) => {
          if (res.status === 200) {
            return res.data
          }
          if (res.status === 204) {
            return res.data
          }
        })
        .catch((error) => {
          showResponseError(error)
        })
      return response
    } catch (error) {
      showResponseError(error)
    }
  },
)

// Get Pre-reserve Paid Stat Details
export const getPreReservePiadStatDetails = createAsyncThunk<
  TReportList<PreReservePaidDeatils[]>,
  QueryParams
>('report/getPreReservePiadStatDetails', async (data: QueryParams) => {
  const query = hasObjectData(data) ? queryStringBuilder(data) : ''
  try {
    const response = await API.get(`${ReportUrl.GetPreReservPaidDetails}${query}`)
      .then((res) => {
        if (res.status === 200) {
          return res.data
        }
        if (res.status === 204) {
          return res.data
        }
      })
      .catch((error) => {
        showResponseError(error)
      })
    return response
  } catch (error) {
    showResponseError(error)
  }
})

// Get Pre-reserve Not Paid Stat
export const getPreReserveNotPaidStat = createAsyncThunk<
  TReportList<PreReserveNotPaid[]>,
  QueryParams
>('report/getPreReserveNotPaidStat', async (data: QueryParams) => {
  const query = hasObjectData(data) ? queryStringBuilder(data) : ''
  try {
    const response = await API.get(`${ReportUrl.GetPreReservNotPaid}${query}`)
      .then((res) => {
        if (res.status === 200) {
          return res.data
        }
        if (res.status === 204) {
          return res.data
        }
      })
      .catch((error) => {
        showResponseError(error)
      })
    return response
  } catch (error) {
    showResponseError(error)
  }
})
// Get Pre-reserve Not Paid Stat Details
export const getPreReserveNotPaidStatDetails = createAsyncThunk<
  TReportList<PreReserveNotPaidDetails[]>,
  QueryParams
>('report/getPreReserveNotPaidStatDetails', async (data: QueryParams) => {
  const query = hasObjectData(data) ? queryStringBuilder(data) : ''
  try {
    const response = await API.get(`${ReportUrl.GetPreReservNotPaidDetails}${query}`)
      .then((res) => {
        if (res.status === 200) {
          return res.data
        }
        if (res.status === 204) {
          return res.data
        }
      })
      .catch((error) => {
        showResponseError(error)
      })
    return response
  } catch (error) {
    showResponseError(error)
  }
})

// Get Pre-reserve Canceled Stat
export const getPreReserveCanceledStat = createAsyncThunk<
  TReportList<PreReserveCanceled[]>,
  QueryParams
>('report/getPreReserveCanceledStat', async (data: QueryParams) => {
  const query = hasObjectData(data) ? queryStringBuilder(data) : ''
  try {
    const response = await API.get(`${ReportUrl.GetPreReservCanceled}${query}`)
      .then((res) => {
        if (res.status === 200) {
          return res.data
        }
        if (res.status === 204) {
          return res.data
        }
      })
      .catch((error) => {
        showResponseError(error)
      })
    return response
  } catch (error) {
    showResponseError(error)
  }
})

// Get Pre-reserve Canceled Stat Details
export const getPreReserveCanceledStatDetails = createAsyncThunk<
  TReportList<TPreReserveCanceledDetails[]>,
  QueryParams
>('report/getPreReserveCanceledStatDetails', async (data: QueryParams) => {
  const query = hasObjectData(data) ? queryStringBuilder(data) : ''
  try {
    const response = await API.get(`${ReportUrl.GetPreReservCanceledDetails}${query}`)
      .then((res) => {
        if (res.status === 200) {
          return res.data
        }
        if (res.status === 204) {
          return res.data
        }
      })
      .catch((error) => {
        showResponseError(error)
      })
    return response
  } catch (error) {
    showResponseError(error)
  }
})

// Get Pre-reserve Stat
export const getPreReserveStat = createAsyncThunk<TReportList<PreReserveStat[]>, QueryParams>(
  'report/getPreReserveStat',
  async (data: QueryParams) => {
    const query = hasObjectData(data) ? queryStringBuilder(data) : ''
    try {
      const response = await API.get(`${ReportUrl.GetPreReservStat}${query}`)
        .then((res) => {
          if (res.status === 200) {
            return res.data
          }
          if (res.status === 204) {
            return res.data
          }
        })
        .catch((error) => {
          showResponseError(error)
        })
      return response
    } catch (error) {
      showResponseError(error)
    }
  },
)

// Get Payments Details
export const getPaymentDetails = createAsyncThunk<TReportList<PaymentReport[]>, QueryParams>(
  'report/getPaymentDetails',
  async (data: QueryParams) => {
    const query = hasObjectData(data) ? queryStringBuilder(data) : ''
    try {
      const response = await API.get(`${ReportUrl.GetPayment}${query}`)
        .then((res) => {
          if (res.status === 200) {
            return res.data
          }
          if (res.status === 204) {
            return res.data
          }
        })
        .catch((error) => {
          showResponseError(error)
        })
      return response
    } catch (error) {
      showResponseError(error)
    }
  },
)

// Get Sajaya Relation Stat
export const getSajayaRelationStat = createAsyncThunk<
  TReportList<SajayaRelationStat[]>,
  QueryParams
>('report/getSajayaRelationStat', async (data: QueryParams) => {
  const query = hasObjectData(data) ? queryStringBuilder(data) : ''
  try {
    const response = await API.get(`${ReportUrl.GetSajayaRelationStat}${query}`)
      .then((res) => {
        if (res.status === 200) {
          return res.data
        }
        if (res.status === 204) {
          return res.data
        }
      })
      .catch((error) => {
        showResponseError(error)
      })
    return response
  } catch (error) {
    showResponseError(error)
  }
})
// Get Cities Stat
export const getCitiesStatByProvinceId = createAsyncThunk<TReportList<CitiesStat[]>, QueryParams>(
  'report/getCitiesStatByProvinceId',
  async (data: QueryParams) => {
    const query = hasObjectData(data) ? queryStringBuilder(data) : ''
    try {
      const response = await API.get(`${ReportUrl.GetCitiesStatByProviceId}${query}`)
        .then((res) => {
          if (res.status === 200) {
            return res.data
          }
          if (res.status === 204) {
            return res.data
          }
        })
        .catch((error) => {
          showResponseError(error)
        })
      return response
    } catch (error) {
      showResponseError(error)
    }
  },
)

const reportSlice = createSlice({
  name: 'report',
  initialState,
  reducers: {
    setCurrentPage: (state, action: PayloadAction<number>) => {
      state.preReserveStatusReport.currentPage = action.payload
    },
    clearPreReserveStatusReport: (state) => {
      state.preReserveStatusReport.list = { total: 0, data: [] }
      state.preReserveStatusReport.currentPage = 1
    },
    clearPreReservePiadReport: (state) => {
      state.preReservePaidReport.paidList = { total: 0, data: [] }
    },
    clearPreReserveNotPiadReport: (state) => {
      state.preReserveNotPaidReport.notPaidList = { total: 0, data: [] }
    },
    clearPreReserveCanceledReport: (state) => {
      state.preReserveCanceledReport.canceledList = { total: 0, data: [] }
    },
    clearPreReserveStatReport: (state) => {
      state.preReserveStatReport.statList = { total: 0, data: [] }
    },
    setPaidSearchParams: (
      state,
      action: PayloadAction<Record<string, string | number | boolean | Date>>,
    ) => {
      state.preReservePaidReport.searchParams = action.payload
    },
    clearPaidSearchParams: (state) => {
      state.preReservePaidReport.searchParams = {}
    },
    setNotPaidSearchParams: (
      state,
      action: PayloadAction<Record<string, string | number | boolean | Date>>,
    ) => {
      state.preReserveNotPaidReport.searchParams = action.payload
    },
    clearNotPaidSearchParams: (state) => {
      state.preReserveNotPaidReport.searchParams = {}
    },
    setCancledSearchParams: (
      state,
      action: PayloadAction<Record<string, string | number | boolean | Date>>,
    ) => {
      state.preReserveCanceledReport.searchParams = action.payload
    },
    clearCancledSearchParams: (state) => {
      state.preReserveCanceledReport.searchParams = {}
    },
    clearSajayaRelationStatReport: (state) => {
      state.sajayaRelationtReport.sajayaRelationtList = { total: 0, data: [] }
    },
    clearCitiesStatReport: (state) => {
      state.citiesStatReport.citiesStatList = { total: 0, data: [] }
    },
  },
  extraReducers: (builder: ActionReducerMapBuilder<IReportInitialState>) => {
    // Get Pre-Reserve Status
    builder.addCase(getPreReserveByStatus.pending, (state) => {
      state.preReserveStatusReport.loading = true
    })
    builder.addCase(
      getPreReserveByStatus.fulfilled,
      (state, action: PayloadAction<TReportList<PreReserveStatus[]>>) => {
        state.preReserveStatusReport.loading = false
        state.preReserveStatusReport.list = action.payload
      },
    )
    builder.addCase(getPreReserveByStatus.rejected, (state) => {
      state.preReserveStatusReport.loading = false
    })

    // Get Pre-Reserve Paid Stat
    builder.addCase(getPreReservePiadStat.pending, (state) => {
      state.preReservePaidReport.paidLoading = true
    })
    builder.addCase(
      getPreReservePiadStat.fulfilled,
      (state, action: PayloadAction<TReportList<PreReservePaid[]>>) => {
        state.preReservePaidReport.paidLoading = false
        state.preReservePaidReport.paidList = action.payload
      },
    )
    builder.addCase(getPreReservePiadStat.rejected, (state) => {
      state.preReservePaidReport.paidLoading = false
    })

    // Get Pre-Reserve Paid Stat Details
    builder.addCase(getPreReservePiadStatDetails.pending, (state) => {
      state.preReservePaidDetailsReport.paidDetailsLoading = true
    })
    builder.addCase(
      getPreReservePiadStatDetails.fulfilled,
      (state, action: PayloadAction<TReportList<PreReservePaidDeatils[]>>) => {
        state.preReservePaidDetailsReport.paidDetailsLoading = false
        state.preReservePaidDetailsReport.paidDetailsList = action.payload
      },
    )
    builder.addCase(getPreReservePiadStatDetails.rejected, (state) => {
      state.preReservePaidDetailsReport.paidDetailsLoading = false
    })

    // Get Pre-Reserve Not Paid Stat
    builder.addCase(getPreReserveNotPaidStat.pending, (state) => {
      state.preReserveNotPaidReport.notPaidLoading = true
    })
    builder.addCase(
      getPreReserveNotPaidStat.fulfilled,
      (state, action: PayloadAction<TReportList<PreReserveNotPaid[]>>) => {
        state.preReserveNotPaidReport.notPaidLoading = false
        state.preReserveNotPaidReport.notPaidList = action.payload
      },
    )
    builder.addCase(getPreReserveNotPaidStat.rejected, (state) => {
      state.preReserveNotPaidReport.notPaidLoading = false
    })

    // Get Pre-Reserve Not Paid Stat Details
    builder.addCase(getPreReserveNotPaidStatDetails.pending, (state) => {
      state.preReserveNotPaidDetailsReport.notPaidDetailsLoading = true
    })
    builder.addCase(
      getPreReserveNotPaidStatDetails.fulfilled,
      (state, action: PayloadAction<TReportList<PreReserveNotPaidDetails[]>>) => {
        state.preReserveNotPaidDetailsReport.notPaidDetailsLoading = false
        state.preReserveNotPaidDetailsReport.notPaidDetilsList = action.payload
      },
    )
    builder.addCase(getPreReserveNotPaidStatDetails.rejected, (state) => {
      state.preReserveNotPaidDetailsReport.notPaidDetailsLoading = false
    })

    // Get Pre-Reserve Canceled Stat
    builder.addCase(getPreReserveCanceledStat.pending, (state) => {
      state.preReserveCanceledReport.canceledLoading = true
    })
    builder.addCase(
      getPreReserveCanceledStat.fulfilled,
      (state, action: PayloadAction<TReportList<PreReserveNotPaid[]>>) => {
        state.preReserveCanceledReport.canceledLoading = false
        state.preReserveCanceledReport.canceledList = action.payload
      },
    )
    builder.addCase(getPreReserveCanceledStat.rejected, (state) => {
      state.preReserveCanceledReport.canceledLoading = false
    })

    // Get Pre-Reserve Canceled Stat Details
    builder.addCase(getPreReserveCanceledStatDetails.pending, (state) => {
      state.preReserveCanceledDetailsReport.canceledDetailsLoading = true
    })
    builder.addCase(
      getPreReserveCanceledStatDetails.fulfilled,
      (state, action: PayloadAction<TReportList<TPreReserveCanceledDetails[]>>) => {
        state.preReserveCanceledDetailsReport.canceledDetailsLoading = false
        state.preReserveCanceledDetailsReport.canceledDetailsList = action.payload
      },
    )
    builder.addCase(getPreReserveCanceledStatDetails.rejected, (state) => {
      state.preReserveCanceledDetailsReport.canceledDetailsLoading = false
    })

    // Get Pre-Reserve  Stat
    builder.addCase(getPreReserveStat.pending, (state) => {
      state.preReserveStatReport.statLoading = true
    })
    builder.addCase(
      getPreReserveStat.fulfilled,
      (state, action: PayloadAction<TReportList<PreReserveNotPaid[]>>) => {
        state.preReserveStatReport.statLoading = false
        state.preReserveStatReport.statList = action.payload
      },
    )
    builder.addCase(getPreReserveStat.rejected, (state) => {
      state.preReserveStatReport.statLoading = false
    })

    // Get Payment Details
    builder.addCase(getPaymentDetails.pending, (state) => {
      state.paymentDetails.paymentLoading = true
    })
    builder.addCase(
      getPaymentDetails.fulfilled,
      (state, action: PayloadAction<TReportList<PaymentReport[]>>) => {
        state.paymentDetails.paymentLoading = false
        state.paymentDetails.paymentList = action.payload
      },
    )
    builder.addCase(getPaymentDetails.rejected, (state) => {
      state.paymentDetails.paymentLoading = false
    })

    // Get Sajaya Relation  Stat
    builder.addCase(getSajayaRelationStat.pending, (state) => {
      state.sajayaRelationtReport.sajayaRelationtLoading = true
    })
    builder.addCase(
      getSajayaRelationStat.fulfilled,
      (state, action: PayloadAction<TReportList<SajayaRelationStat[]>>) => {
        state.sajayaRelationtReport.sajayaRelationtLoading = false
        state.sajayaRelationtReport.sajayaRelationtList = action.payload
      },
    )
    builder.addCase(getSajayaRelationStat.rejected, (state) => {
      state.sajayaRelationtReport.sajayaRelationtLoading = false
    })

    // Get Cities  Stat
    builder.addCase(getCitiesStatByProvinceId.pending, (state) => {
      state.citiesStatReport.citiesStatLoading = true
    })
    builder.addCase(
      getCitiesStatByProvinceId.fulfilled,
      (state, action: PayloadAction<TReportList<CitiesStat[]>>) => {
        state.citiesStatReport.citiesStatLoading = false
        state.citiesStatReport.citiesStatList = action.payload
      },
    )
    builder.addCase(getCitiesStatByProvinceId.rejected, (state) => {
      state.sajayaRelationtReport.sajayaRelationtLoading = false
    })
  },
})

export const {
  setCurrentPage,
  clearPreReserveStatusReport,
  clearPreReservePiadReport,
  clearPreReserveNotPiadReport,
  clearPreReserveCanceledReport,
  clearPreReserveStatReport,
  clearSajayaRelationStatReport,
  setPaidSearchParams,
  clearPaidSearchParams,
  setNotPaidSearchParams,
  clearNotPaidSearchParams,
  setCancledSearchParams,
  clearCancledSearchParams,
  clearCitiesStatReport,
} = reportSlice.actions

export default reportSlice.reducer
